import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45130fa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "placeholder _prevent-text-select" }
const _hoisted_2 = ["src"]

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Engder',
  props: {
  level: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'kids',
  },
  email: {
    type: String,
    default: '',
  },
  classId: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

const engderPath = computed(() => {
  return props.type == 'kids'
    ? `https://engder.globish.co.th/kids/${props.level}?user=${props.email}&classId=${props.classId}`
    : `https://engder.globish.co.th/?level=${props.level}?user=${props.email}&classId=${props.classId}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      src: engderPath.value,
      allow: "microphone",
      frameborder: "0"
    }, null, 8, _hoisted_2)
  ]))
}
}

})